<div class="modal-header" appCustomAutofocus>
        <h3 class="modal-title">Confirm Proxy Benefit Submissions</h3>
    </div>
    <div class="modal-body modal-scroll" id="modal_size">
        <div *ngIf="proxyData == null">
            <div class="card border" [style.width.px]="450">
                <div class="card-header bg-light">Please sign in the box below to acknowledge that you have read and understand the contents of the document underneath.</div>
                <div class="card-body" [style.width.px]="450" style="background-color:#d4d4d4;border:1px solid black;border-radius:5px;">
                    <div class="alert alert-info" style="margin:10px;" *ngIf="showClickMsg">Press "Clear" before generating your signature image.</div>
                    <div class="m-signature-pad">
                        <div class="m-signature-pad--body" [ngClass]="{inValidSign: redBorder == true}" *ngIf="submitSignImg == null">
                            <signature-pad [options]="signaturePadOptions" #signaturePad></signature-pad>
                        </div>
                        <div *ngIf="submitSignImg != null" style="background-color:white;border:1px solid black">
                            <img src="{{submitSignImg}}" [style.max-width.px]="panelWidth-50" />
                        </div>
                        <div class="m-signature-pad--footer">
                            <div style="text-align: center;font-size: 12px;">Sign above</div>
                            <button type="button" class="btn btn-outline-dark" (click)="clearSignature()">Clear</button>
                            <button type="button" class="btn btn-outline-dark" (click)="clickSign('full')" *ngIf="EnableCheckboxSign && !hideClick">Generate Signature</button>
                            <div class="alert alert-warning" style="margin:10px;">By signing above, I agree that the signature and initials will be the electronic representation of my signature and initials for all purposes when I (or my agent) use them on documents, including legally binding contracts - just the same as a pen-and-paper signature or initial.</div>
                        </div>
                    </div>
                </div>
            </div>

            <p>Upon submission, your updates will be routed to your administrator for review and approval.</p>
        </div>
        <div *ngIf="proxyData != null">
            You are submitting the benefit elections as a proxy for {{proxyData.FullName}}.  This election window will be marked as finalized without an employee signature since you are submitting as an administrator.

        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-dark" (click)="closeSignature()">Cancel</button>
        <button type="button" class="btn btn-success" (click)="submitSignature()">Submit</button>
    </div>